document.addEventListener('DOMContentLoaded', function () {
    const templates = document.querySelectorAll('.template');

    templates.forEach(template => {
        const file = template.getAttribute('data-template');

        if (file) { 
            fetch(file)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Error loading file : ' + file + ' Status: ' + response.status);
                    }
                    return response.text();
                })
                .then(data => {
                    template.innerHTML = data;
                    
                    const event = new CustomEvent('templateLoaded', {
                        bubbles: true, 
                        detail: { file: file } 
                    });
                    
                    template.dispatchEvent(event);
                    // ----------------------------------------------------
                })
                .catch(error => {
                    console.error('Error loading template:', error);
                    template.innerHTML = `<div class="alert alert-danger">Failed to load content from ${file}.</div>`; 
                });
        } else {
            console.warn('Template element found without data-template attribute:', template);
        }
    });
});